import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useGeneralState } from "../../../redux/general/selectors";
import { baseUrl } from "../../../config/globalVariables";

const intercomScript = `
(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/h63agw0k';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
`;

declare global {
  interface Window {
    Intercom: (event: string, options?: any) => void;
  }
}

const useIntercom = (): void => {
  const location = useLocation();
  const isBooted = useRef(false);
  const intecom = window.Intercom;
  const user = useGeneralState();
  const userData = user?.self?.data;

  useEffect(() => {
    if (process.env.REACT_APP_ENV !== "production") {
      return;
    }

    const jsScript = document.createElement("script");

    jsScript.innerHTML = intercomScript;

    document.head.appendChild(jsScript);
  }, []);

  // Initialize intercom
  useEffect(() => {
    if (userData && !!intecom && !isBooted.current) {
      const companies: Record<string, string | undefined>[] = [];
      const roles: Record<string, string | undefined>[] = [];
      userData.roles?.forEach((r) => {
        companies.push({
          id: r.rootCompany,
          name: r.rootCompanyName,
        });
        roles.push({
          external_id: r.id.toString(),
          company_id: r.rootCompany,
          company_name: r.rootCompanyName,
          role_type: r.type,
        });
      });
      const rolesDescription = userData.roles
        ?.map((r) => `${r.rootCompanyName} (${r.type})`)
        .join(", ");
      intecom("boot", {
        api_base: "https://api-iam.intercom.io",
        app_id: "h63agw0k",
        custom_launcher_selector: "#chat_launcher",
        hide_default_launcher: true,
        email: userData.email,
        name: userData.firstName + " " + userData.lastName,
        avatar: userData.imgLink
          ? baseUrl + "/file/account/" + userData.imgLink
          : undefined,
        user_hash: userData.intercomHmac,
        phone: userData.phoneNumber,
        "Roles Description": rolesDescription,
        roles: roles,
        companies: companies,
      });
      isBooted.current = true;
    }
  }, [intecom, userData]);

  // Update on location change
  useEffect(() => {
    if (intecom && isBooted.current) {
      intecom("update");
    }
  }, [intecom, location]);
};
export default useIntercom;
